module.exports = __webpack_public_path__ + "img/404.b8aa39d.jpg";